import { Mapper } from 'planning-portal-library/src/lib/core/base';
import { PublicLocationWebEntity } from './public-location-web-entity';
import { GLSLocation } from 'planning-portal-library/src/lib/core/domain/models/gls-location';

export class PublicLocationWebRepositoryMapper extends Mapper<
  PublicLocationWebEntity,
  GLSLocation
> {
  mapFrom(param: PublicLocationWebEntity): GLSLocation {
    return {
      planId: param.planId,
      jobId: param.jobId,
      address: param.address,
      id: param.id,
      segmentId: param.segmentId,
      latitude: param.latitude,
      sequenceNumber: param.sequenceNumber,
      longitude: param.longitude,
    };
  }

  mapTo(param: GLSLocation): PublicLocationWebEntity {
    return {
      planId: param.planId,
      jobId: param.jobId,
      address: param.address,
      segmentId: param.segmentId,
      id: param.id,
      latitude: param.latitude,
      sequenceNumber: param.sequenceNumber,
      longitude: param.longitude,
    };
  }
}
